import { render, staticRenderFns } from "./ech-button.vue?vue&type=template&id=0ede01e1&"
import script from "./ech-button.vue?vue&type=script&lang=js&"
export * from "./ech-button.vue?vue&type=script&lang=js&"
import style0 from "./ech-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports